// extracted by mini-css-extract-plugin
export default {"fab":"AgFab_fab__tC43t","lg":"AgFab_lg__-3Qq+","sm":"AgFab_sm__M8DKh","primary":"AgFab_primary__CE4CP","secondary":"AgFab_secondary__j9Inh"};